import { HTMLMotionProps } from "motion/react";

export const fadeInAnimation = ({
  delay,
}: {
  delay?: number;
}): HTMLMotionProps<"div"> => ({
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: false },
  transition: { delay: delay || 0.2, duration: 1.1, ease: "easeInOut" },
});
